<div
  data-test="1PelmEfo"
  class="modal modal-compact"
  id="modalSelectRole"
  [class.active]="show"
>
  <div
    data-test="FcR0Uh0a"
    class="modal__overlay"
    data-close="modal"
    (click)="toggleModalHandle(false)"
  ></div>
  <div data-test="z0AZhOKN" class="modal__wrap" *ngIf="model">
    <div data-test="dfda_5iw" class="modal__window">
      <div data-test="chDqdcFQ" class="modal__content">
        <button
          data-test="Btne8nzQ"
          class="modal__close"
          data-close="modal"
          (click)="toggleModalHandle(false)"
        >
          <span data-test="8hMDruOG" class="badge badge_gray">
            <i data-test="v15sjYyB" class="material-icons md-12">close</i>
          </span>
        </button>
        <div
          data-test="uock6r2z"
          class="modal__content-wrap scrollbar-hidden"
          data-simplebar
        >
          <div data-test="8tDchjGy" class="modal__container">
            <div data-test="78x1B5Ks" class="modal__body">
              <ng-container *ngIf="!actionType; else bookModalConfirmBody">
                <h2
                  data-test="5nve8aDH"
                  class="modal__title modal__title_center h1"
                  *ngIf="!compositionRoleUuidControl?.value; else bpSelectedTitle"
                >
                  <span data-test="D46kuN0h" class="font-weight-normal">Book&nbsp;</span>
                  <b data-test="tH5DEhiy">
                    {{ model.externalUser.fullName }}
                  </b>
                </h2>
                <ng-template #bpSelectedTitle>
                  <div data-test="KY9NIcHi" class="modal__title">
                    <span data-test="zL9QROQS" class="h1">
                      <span data-test="HCxYFp4h" class="font-weight-normal">Book</span>
                      {{ model.externalUser.fullName }}
                    </span>
                    <div data-test="ekFu02JN" class="h2">
                      <span data-test="oM4u_vmX" class="font-weight-normal">as</span>
                      {{
                        getCompositionRoleNameByUuid(
                          $any(compositionRoleUuidControl.value)
                        )
                      }}
                    </div>
                  </div>
                </ng-template>
                <form data-test="RFUHdMjF" class="form form_sm">
                  <div
                    data-test="qVG_2CKq"
                    class="form-group form-group_sm"
                    *ngIf="compositionRoleUuidControl"
                  >
                    <label data-test="fDDDG6Ot" class="form-group__label">
                      Select role
                    </label>
                    <div
                      data-test="LosS0cbF"
                      class="form-group__field form-group__field_append"
                    >
                      <md-dropdown
                        data-test="9Xip5y_n"
                        valueKey="uuid"
                        labelKey="roleName"
                        [trackBy]="bookModalRolesTrackBy"
                        [options]="getBookModalRolesOptions()"
                        [ngrxFormControlState]="compositionRoleUuidControl"
                      ></md-dropdown>
                      <label
                        data-test="jOnuCpbb"
                        class="form-group__field-append link-light"
                      >
                        <i data-test="8UVn4jq9" class="material-icons md-16">
                          keyboard_arrow_down
                        </i>
                      </label>
                    </div>
                  </div>

                  <div data-test="RSPKQO0f" class="form-group form-group_sm">
                    <div data-test="sxghpU0M" class="message-alert message-alert_gray">
                      <div data-test="GKjTS57N" class="message-alert__header">
                        <h4 data-test="8rLiPfXm">*Notes:</h4>
                      </div>
                      <div data-test="dZvZ64ME" class="message-alert__text">
                        <p data-test="T4J2K2wB">
                          <b data-test="b5_UeKyY">Send request</b>
                          will send an email for user confirmation.
                        </p>
                        <p data-test="o5_w1_zG">
                          <b data-test="UIlWBjTA">Manual booking</b>
                          will confirm booking without user confirmation.
                        </p>
                      </div>
                    </div>
                  </div>
                </form>
              </ng-container>
              <ng-template #bookModalConfirmBody>
                <h2 data-test="NFb709Hx" class="h1 modal__title modal__title_center">
                  <span data-test="puOhJ8Ap" class="font-weight-normal">
                    <ng-container *ngIf="actionType === actionTypes.MANUAL_BOOKING">
                      Book
                    </ng-container>
                    <ng-container *ngIf="actionType === actionTypes.SEND_REQUEST">
                      Send request to book
                      <br data-test="oKdK-rke" />
                    </ng-container>
                    <b data-test="eKYJo82h">
                      {{ model.externalUser.fullName }}
                      <br data-test="5hvbk5L5" />
                    </b>

                    as
                    <b data-test="DRI_aBiX">
                      {{
                        getCompositionRoleNameByUuid(
                          $any(compositionRoleUuidControl.value)
                        )
                      }}
                    </b>
                    ?
                  </span>
                </h2>
                <ng-container *ngIf="!checking; else modalChecking">
                  <div
                    data-test="i3mygjdK"
                    class="accordion"
                    *ngIf="canShowBookModalIssues()"
                  >
                    <div
                      data-test="wuZq-lSw"
                      class="accordion__card accordion__card_error"
                      [class.accordion__card_active]="showErrors"
                      (click)="toggleErrors()"
                      *ngIf="checks.errors.length !== 0"
                    >
                      <div data-test="oLNJMAs7" class="accordion__card-title">
                        <span data-test="odB7VyJf" class="accordion__card-title-icon">
                          <i data-test="juDI2YSI" class="material-icons">
                            keyboard_arrow_right
                          </i>
                        </span>
                        <span data-test="OZ_dINm8" class="accordion__card-title-text">
                          {{ checks.errors.length }} fatal errors
                        </span>
                      </div>
                      <div
                        data-test="6HoygKms"
                        class="accordion__card-content"
                        style="display: block"
                        *ngIf="showErrors"
                      >
                        <ng-container
                          *ngFor="let error of checks.errors; let isLast = last"
                        >
                          {{ error }}
                          <br data-test="8aXkAYdM" *ngIf="!isLast" />
                        </ng-container>
                      </div>
                    </div>
                    <div
                      data-test="3GmVQAvw"
                      class="accordion__card accordion__card_warning"
                      [class.accordion__card_active]="showWarnings"
                      (click)="toggleWarnings()"
                      *ngIf="checks.warnings.length !== 0"
                    >
                      <div data-test="0npATObY" class="accordion__card-title">
                        <span data-test="GGCz0xTL" class="accordion__card-title-icon">
                          <i data-test="DAqUArSk" class="material-icons">
                            keyboard_arrow_right
                          </i>
                        </span>
                        <span data-test="1YhV1dY5" class="accordion__card-title-text">
                          {{ checks.warnings.length }} warnings
                        </span>
                      </div>
                      <div
                        data-test="se58aNmw"
                        class="accordion__card-content"
                        style="display: block"
                        *ngIf="showWarnings"
                      >
                        <ng-container
                          *ngFor="let warning of checks.warnings; let isLast = last"
                        >
                          {{ warning }}
                          <br data-test="PRs_oMXq" *ngIf="!isLast" />
                        </ng-container>
                      </div>
                    </div>
                    <div
                      data-test="cuekkOEO"
                      class="accordion__card accordion__card_info"
                      [class.accordion__card_active]="showRemarks"
                      (click)="toggleRemarks()"
                      *ngIf="checks.remarks.length !== 0"
                    >
                      <div data-test="NO7IlmZm" class="accordion__card-title">
                        <span data-test="kzLZ3ndo" class="accordion__card-title-icon">
                          <i data-test="vPKFiijN" class="material-icons">
                            keyboard_arrow_right
                          </i>
                        </span>
                        <span data-test="YHIS4xg4" class="accordion__card-title-text">
                          {{ checks.remarks.length }} remarks
                        </span>
                      </div>
                      <div
                        data-test="LuL2fBmM"
                        class="accordion__card-content"
                        style="display: block"
                        *ngIf="showRemarks"
                      >
                        <ng-container
                          *ngFor="let remark of checks.remarks; let isLast = last"
                        >
                          {{ remark }}
                          <br data-test="nyuauBcl" *ngIf="!isLast" />
                        </ng-container>
                      </div>
                    </div>
                    <div
                      data-test="aznfP2Lh"
                      class="accordion__card accordion__card_default"
                      [class.accordion__card_active]="showInfo"
                      (click)="toggleInfo()"
                      *ngIf="checks.info.length !== 0"
                    >
                      <div data-test="xKDbBUwt" class="accordion__card-title">
                        <span data-test="_F3S2ZIg" class="accordion__card-title-icon">
                          <i data-test="yki50fUK" class="material-icons">
                            keyboard_arrow_right
                          </i>
                        </span>
                        <span data-test="tebrnXWr" class="accordion__card-title-text">
                          {{ checks.info.length }} info
                        </span>
                      </div>
                      <div
                        data-test="MHyLrP7a"
                        class="accordion__card-content"
                        style="display: block"
                        *ngIf="showInfo"
                      >
                        <ng-container *ngFor="let info of checks.info; let isLast = last">
                          {{ info }}
                          <br data-test="lBCRzfR6" *ngIf="!isLast" />
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #modalChecking>
                  <div data-test="zh3CJPkb" class="text-center">Checking...</div>
                  <div data-test="WynvUKi7" class="text-center">
                    <md-loader data-test="4vQi6FT8" class="d-inline"></md-loader>
                  </div>
                </ng-template>
                <p
                  data-test="NCPrrIVR"
                  class="text-center"
                  *ngIf="canShowResponsibilityWarning()"
                >
                  This will be on your own
                  <b data-test="NBpYZnD2">responsibility</b>
                </p>
              </ng-template>
            </div>
          </div>
        </div>
        <footer
          data-test="StAlDnGk"
          class="modal__footer modal__footer_white modal__footer_grow"
        >
          <div data-test="EF2ivnp5" class="modal__container">
            <div
              data-test="hy1QO7FX"
              class="row align-items-center justify-content-center gutters-20"
            >
              <ng-container *ngIf="!actionType; else bookModalConfirmFooter">
                <div data-test="iKQST0Op" class="col">
                  <button
                    data-test="Obb-NfFE"
                    class="button_ button button_secondary button_text-14"
                    (click)="
                      stopPropagation($event);
                      selectActionType.emit(actionTypes.MANUAL_BOOKING)
                    "
                  >
                    Manual booking
                  </button>
                </div>
                <div data-test="T9tL1Omm" class="col">
                  <button
                    data-test="U4BjaBPz"
                    class="button_ button button_primary button_text-14"
                    data-close="modal"
                    (click)="
                      stopPropagation($event);
                      selectActionType.emit(actionTypes.SEND_REQUEST)
                    "
                  >
                    Send request
                  </button>
                </div>
              </ng-container>
              <ng-template #bookModalConfirmFooter>
                <div data-test="8ZL5LYd4" class="col-auto">
                  <button
                    data-test="jJMojQZb"
                    class="button_ button button_gray-outline button_text-14"
                    (click)="toggleModalHandle(false)"
                  >
                    Cancel
                  </button>
                </div>
                <div data-test="Rh7c6bbZ" class="col">
                  <button
                    data-test="Hrxg0wVP"
                    class="button_ button button_primary button_text-14"
                    data-close="modal"
                    [mdButtonSpinner]="isBookingInProgress || checking"
                    [disabled]="checks.errors.length !== 0"
                    (click)="makeBooking.emit(actionType)"
                    [ngPlural]="checks.warnings.length"
                  >
                    <ng-template ngPluralCase="=0">Proceed</ng-template>
                    <ng-template ngPluralCase="=1">Proceed with 1 warning</ng-template>
                    <ng-template ngPluralCase="other">
                      Proceed with {{ checks.warnings.length }} warnings
                    </ng-template>
                  </button>
                </div>
              </ng-template>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</div>
